var map = {
	"./art-work0.jpeg": 7140,
	"./art-work2 (3).jpeg": 8618,
	"./art-work2.jpeg": 6014,
	"./art-work3 (3).jpeg": 5465,
	"./art-work3 .jpeg": 971,
	"./art-work3.jpeg": 9349,
	"./art-work4.jpeg": 4896,
	"./art-work5 (3).jpeg": 6527,
	"./art-work5.jpeg": 423,
	"./art-work6 (3).jpeg": 5222,
	"./art-work6 .jpeg": 7246,
	"./art-work6.jpeg": 349,
	"./art-work7 (3).jpeg": 7125,
	"./art-work7 .jpeg": 7791,
	"./art-work7.jpeg": 5777,
	"./art-work8.jpeg": 3468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3410;